import styled from "styled-components";

export const Container = styled.div`
  min-height: 200px;

  p {
    font-weight: 500;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      color: #fff;
      background-color: #979797;
      padding: 10px 20px;
    }

    span {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .loader::after {
    border-color: #000 transparent transparent !important;
  }

  a {
    padding: 5px 10px;
    border: 1px solid #000;
    border-radius: 5px;
  }
`
